import React, { Component, PropTypes } from 'react'
import NumberFormat from 'react-number-format'
import NumberInputWithFeedback from '../NumberInputWithFeedback'
import styles from './PointRule.css'

class PointRule extends Component {
  constructor (props) {
    super(props)
    let { spendingAmount, pointFromSpendingAmount } = props
    let amountInputError = spendingAmount === '' ? null : this._getAmountInputError(spendingAmount)
    let pointInputError = pointFromSpendingAmount === '' ? null : this._getPointInputError(pointFromSpendingAmount)
    this.state = {
      amountInputError,
      pointInputError
    }
  }
  render () {
    const { amountInputError, pointInputError } = this.state
    let isDisabledNext = amountInputError !== '' || pointInputError !== ''

    return (
      <div className='top20'>
        <div className='row bottom20'>
          <div className={`col-md-12 ${styles['action-label']}`}>
            Set your point conversion
          </div>
        </div>
        <div className='bottom30'>
          <div className={`${styles['wrapped-input']}`}>
            <NumberInputWithFeedback
              inputValue={this.props.spendingAmount}
              onChangeValue={this._onChangeAmount}
              prefix='Rp. '
              placeholder='Rp. 0'
              errorMessage={this.state.amountInputError}
            />
          </div>
          <div className={`text-center ${styles['middle-equal']}`}>
            =
          </div>
          <div className={`${styles['wrapped-input']}`}>
            <NumberInputWithFeedback
              inputValue={this.props.pointFromSpendingAmount}
              onChangeValue={this._onChangePoint}
              suffix=' Points'
              placeholder='0 Points'
              errorMessage={this.state.pointInputError}
            />
          </div>
        </div>
        <div className='row bottom20'>
          <div className={`col-md-12 ${styles['action-label']}`}>
            Offer new member points to join loyalty program (Optional)
          </div>
        </div>
        <div className={`${styles['wrapped-input']}`}>
          <div>
            <div className='has-feedback'>
              <NumberFormat
                className='form-control form-control-success'
                value={this.props.newMemberPoint}
                onChange={this._onChangeNewMemberPoint}
                suffix=' Points'
                placeholder='0 Points'
                thousandSeparator='.'
                decimalPrecision={0}
                decimalSeparator=','
                allowNegative={false}
              />
            </div>
          </div>
        </div>
        <div className='top20'>
          <button
            style={{color: `${isDisabledNext ? '' : '#3e8acc'}`}}
            className='btn btn-default pull-right'
            onClick={this._onClickNext}
            disabled={isDisabledNext}
          >
            Next
          </button>
        </div>
      </div>
    )
  }

  _onChangeAmount = (e, rawAmount) => {
    let maximum = 999999999999
    let amountInputError = this._getAmountInputError(rawAmount)
    if (rawAmount > maximum) {
      rawAmount = this.props.spendingAmount
    }

    if ($.isNumeric(rawAmount)) {
      rawAmount = parseInt(rawAmount)
    }

    this.props.setSpendingAmount(rawAmount)
    this.setState({amountInputError})
  }

  _getAmountInputError = (amount) => {
    let amountInputError = ''
    if (!amount) {
      amountInputError = 'Please enter a value'
    } else if (amount < 1000) {
      amountInputError = 'Minimum value is Rp 1000'
    }

    return amountInputError
  }

  _onChangePoint = (e, rawPoint) => {
    let maximum = 999999999999
    if (rawPoint > maximum) {
      rawPoint = this.props.pointFromSpendingAmount
    }

    if ($.isNumeric(rawPoint)) {
      rawPoint = parseInt(rawPoint)
    }

    let pointInputError = this._getPointInputError(rawPoint)
    this.props.setPointFromSpendingAmount(rawPoint)
    this.setState({pointInputError})
  }

  _getPointInputError = (point) => {
    let pointInputError = ''
    if (point <= 0) {
      pointInputError = 'Please enter a value'
    }

    return pointInputError
  }

  _onChangeNewMemberPoint = (e, rawPoint) => {
    let maximum = 999999999999
    if (rawPoint > maximum) {
      rawPoint = this.props.newMemberPoint
    }

    if ($.isNumeric(rawPoint)) {
      rawPoint = parseInt(rawPoint)
    }

    this.props.setNewMemberPoint(rawPoint)
  }

  _onClickNext = (e) => {
    e.stopPropagation()
    this.props.onFinish()
  }

}

PointRule.propTypes = {
  spendingAmount: PropTypes.number.isRequired,
  pointFromSpendingAmount: PropTypes.func.isRequired,
  newMemberPoint: PropTypes.number.isRequired,
  setSpendingAmount: PropTypes.func.isRequired,
  setPointFromSpendingAmount: PropTypes.func.isRequired,
  onFinish: PropTypes.func.isRequired
}

export default PointRule



// WEBPACK FOOTER //
// ./app/pages/Customers/Loyalty/Components/Program/PointRule/PointRule.js